<template>
  <div class="productandServices">
    <b-container>
      <b-row class>
        <b-col >
          <Headings :data="heading" />
          <p v-if="showmode" class="sub-heading" >{{subheading}}</p>
          <b-row class="main-content">
            <b-col lg="3" sm="12" class="block-section"  v-for="(service, index) in Services" :key="index">
              <b-row align-h="center" class="mb-3">
                <b-col cols="8" class="service px-1">
                  <img class="image" alt="Products and Services Image" v-lazy="require(`@/assets/icons/${service.image}`)" />
                </b-col>
              </b-row>
              <div class="info">
                <b-row align-h="center">
                  <b-col>{{ service.infos }}</b-col>
                </b-row>
              </div>
              <div class="info" v-if="visibility">
                <b-row align-h="center">
                  <b-col>{{ service.detail }}</b-col>
                </b-row>
              </div>
              <div class="additional-info">
                <b-row align-h="center" class="mx-auto additional-info-text p-1">
                  <b-col align-h="center">{{ service.additional }}</b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: "ProductServices",
  props: ["Services", "heading", "visibility","subheading","showmode"],
  data() {
    return {
      
    };
  },
  methods: {
    
  }
};
</script>
<style scoped>
.info {
  color: var(--mainBlueColor);
  font-size: 22px;
  min-height: 100px;
  font-weight: 700;
  padding-top: 1rem;
  text-align: center;
  margin-bottom: 1rem;
}
.additional-info {
  color: var(--mainBlueColor);
  font-size: 14px;
  min-height: 100px;
}
.main-content {
 /* margin-top: 5rem; */
  justify-content: center;
}
.image {
  height: 100px;
  width: 100px;
  /* -webkit-filter: drop-shadow(0px 3px 10px rgba(0,0,0,0.4));
  filter: drop-shadow(0px 2px 12px rgba(0,0,0,0.4));  */
  /*-webkit-filter: drop-shadow(0px 3px 1px rgba(0, 0, 0, 0.4));
  filter: drop-shadow(0px 2px 1px rgba(0, 0, 0, 0.4));
  */
  -webkit-filter: drop-shadow(0 0 1px rgba(0, 0, 0, 0.4));
  filter: drop-shadow(0 0 1px rgba(0, 0, 0, 0.4));
}
.waypoint {
  background-color: red;
}
.sub-heading{
  text-align:left;
  color:var(--mainBlueColor);
  margin-top:2rem;
  font-size:1rem;
}

/* Media Queries */
/* Tablet Views */
@media (min-width: 768px) and (max-width: 1024px) and (orientation: portrait) {
  .info {
    font-size: 1.125rem;
    min-height: 30px;
    padding-top: 0;
    margin-bottom: 0;
  }
  .additional-info {
    font-size: 0.9rem;
    min-height: 70px;
  }
  .image {
    height: 100px;
    width: 100px;
  }
  .main-div {
    padding-left: 15px;
    padding-right: 15px;
  }
  .main-content {
    margin-top: 2rem;
  }
  .sub-heading{
    text-align:center;
    margin-bottom: 0;
  }
  /*
  .productandServices {
    padding-top: 1.5rem;
  }*/
}
@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  .info {
    font-size: 1.125rem;
    min-height: 30px;
    padding-top: 0;
    margin-bottom: 0;
  }
  .additional-info {
    font-size: 0.9rem;
    min-height: 70px;
  }
  .image {
    height: 100px;
    width: 100px;
  }
  .main-div {
    padding-left: 15px;
    padding-right: 15px;
  }
  .main-content {
    margin-top: 2rem;
  }
  /*
  .productandServices {
    padding-top: 1.5rem;
  }*/
   .sub-heading{
    text-align:center;
    margin-bottom: 0;
  }
}
/* Mobile Views */
@media (min-width: 481px) and (max-width: 767px) {
  .info {
    font-size: 17px;
    min-height: 30px;
    padding-top: 0;
    margin-bottom: 0;
  }
  .additional-info {
    font-size: 0.75rem;
    min-height: 60px;
  }
  .image {
    height: 90px;
    width: 90px;
  }
  .main-div {
    padding-left: 15px;
    padding-right: 15px;
  }
  .main-content {
    margin-top: 0;
  }
  /*
  .productandServices {
    padding-top: 1.5rem;
  }*/
   .sub-heading{
    text-align:center;
    margin-bottom: 0;
  }
  .block-section{
    margin-top:2rem;

  }
}
@media (max-width: 480px) {
  .info {
    font-size: 17px;
    min-height: 30px;
    padding-top: 0;
    margin-bottom: 0;
  }
  .additional-info {
    font-size: 0.75rem;
    min-height: 60px;
  }
  .image {
    height: 80px;
    width: 80px;
  }
  .main-div {
    padding-left: 15px;
    padding-right: 15px;
  }
  .main-content {
    margin-top: 0;
  }
  .block-section{
    margin-top:2rem;

  }
  
  /*
  .productandServices {
    padding-top: 1.5rem;
  }*/
   .sub-heading{
    text-align:center;
    margin-bottom: 0;
  }
}
</style>
